import { render, staticRenderFns } from "./SortableTh.vue?vue&type=template&id=62a011b8&scoped=true"
import script from "./SortableTh.vue?vue&type=script&lang=js"
export * from "./SortableTh.vue?vue&type=script&lang=js"
import style0 from "./SortableTh.vue?vue&type=style&index=0&id=62a011b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a011b8",
  null
  
)

export default component.exports